import { TelemetryErrorEvent } from './telemetry-error-event';
import { TelemetryPageViewEvent } from './telemetry-page-view-event';
import { TelemetryEvent } from './telemetry-event';

export abstract class TelemetryProvider {
	public abstract trackEvent(event: TelemetryEvent): void;

	public abstract trackPageView(event: TelemetryPageViewEvent): void;

	public abstract trackError(event: TelemetryErrorEvent): void;
}
